import React from 'react';

function err() {
    return(
      <h1> 404 not found </h1>
    )
}

export default err;
